export { Coordinates, latitudeValues, longitudeValues } from './Coordinates'
